import React from "react";
import * as s from "./styles";

export const WithdrawnByInactivityCaseInformation = () => (
  <s.Container>
    <s.Wrapper aria-labelledby="case-withdrawn-title">
      <h1 className="h1 color-text-on-surface" id="case-withdrawn-title">
        Your screening has been closed
      </h1>
      <p className="body-wide-line color-text-subdued margin-t-1  margin-b-1">
        We have not received your completed information and have, therefore,
        closed your screening profile.
      </p>
      <p className="body-wide-line color-text-subdued margin-t-1  margin-b-1">
        If you still wish to proceed with the screening process, please reach
        out to your contact at the company requesting the screening, and they
        will be able to initiate a new profile for you.
      </p>
      <p className="body-wide-line color-text-subdued margin-t-1">
        Please note that any information you have already provided will be
        securely deleted in accordance with our privacy policy. For more
        details, you can refer to the Privacy Policy link at the bottom of this
        page.
      </p>
    </s.Wrapper>
  </s.Container>
);
